<div class="contact-content">
    <div class="back-button">
        <mat-icon routerLink="/blog">arrow_back</mat-icon>
    </div>
    <div class="blog-text">
        <h3>BLOG HOZZÁADÁSA</h3>
        <p [ngStyle]="{ 'text-align': 'center' }">A * - al jelölt mezők kitöltése kötelező!</p>
    </div>
    <div class="contact-form">
        <form [formGroup]="blogForm!" novalidate>
            <div class="field-container">
                <div class="field">
                    <b>Blog neve *</b>
                    <div class="data">
                        <input [(ngModel)]="blog.title" formControlName="title" id="title" class="form-control" type="text" required />
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <b>Blog szövege *</b>
                    <pw-fileexplorer></pw-fileexplorer>
                    <div class="data">
                        <app-tinymcehtmleditor
                            [html]="blog.innerHtml!"
                            [htmlForm]="htmlForm"
                            id="html"
                            class="form-control"
                            type="text"
                            required
                            ngDefaultControl
                        ></app-tinymcehtmleditor>
                    </div>
                </div>
            </div>
        </form>
        <div class="field-container">
            <div class="field">
                <b>Blog thumb kép * (.jpg vagy .png)</b>
                <div class="data">
                    <div class="image-container">
                        <button [ngStyle]="{ background: 'lightgrey' }" onclick="document.getElementById('fileCover').click()">
                            Kép kiválasztása
                        </button>
                        <span *ngIf="uploadThumbFile">{{ fileCover?.name }}</span>
                        <mat-icon (click)="clearSelectedCoverFile()">delete_forever</mat-icon>
                        <input
                            [ngStyle]="{ display: 'none' }"
                            id="fileCover"
                            #fileCoverInput
                            class="form-control"
                            type="file"
                            (change)="onChange($event)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div [ngStyle]="{ 'margin-top': '8px' }" class="field-container">
            <div [ngStyle]="{ 'justify-content': 'center', 'margin-top': '8px', 'margin-bottom': '8px' }" class="field">
                <div [ngStyle]="{ 'justify-content': 'center' }" class="data">
                    <button
                        (click)="addBlog()"
                        [ngStyle]="{ background: '#eee', border: '1px solid #0E8388', 'font-weight': 'bold', width: '100%' }"
                        [disabled]="!blogForm?.valid"
                    >
                        BLOG MENTÉSE
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
